var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439 280.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.37,238.88V57.35a8.51,8.51,0,0,0-8.69-8.25H8.68A8.5,8.5,0,0,0,0,57.35V238.88a8.49,8.49,0,0,0,8.68,8.25h191A8.51,8.51,0,0,0,208.37,238.88ZM191,65.6v69.56l-21.88-20.79a9.06,9.06,0,0,0-12.32,0L93.16,174.85l-34.3-32.59a8.94,8.94,0,0,0-6.07-2.39,9.19,9.19,0,0,0-6.17,2.39L17.36,170.07V65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,84C76.58,84,66.11,94,66.11,106.23s10.46,22.22,23.37,22.22,23.38-9.95,23.38-22.22h0C112.85,94,102.39,84,89.49,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.41,82.11a8.47,8.47,0,0,0-8.68,8.25V263.64H43.41a8.26,8.26,0,1,0,0,16.5h191a8.47,8.47,0,0,0,8.68-8.25V90.36A8.47,8.47,0,0,0,234.41,82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.19,138.32h12a2.29,2.29,0,0,1,2.39,2.15v56.86c0,9.47-8.6,17.17-19.17,17.17H305.54l7.72,6.91a7,7,0,0,1,0,10.62,9.11,9.11,0,0,1-11.87,0l-26.27-23.52a2,2,0,0,1,0-3L301.39,182a9.11,9.11,0,0,1,11.87,0,7,7,0,0,1,0,10.62l-7.71,6.91h32.67a3.44,3.44,0,0,0,3.6-3.22V140.49A2.24,2.24,0,0,1,344.19,138.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,11.7c0,4.52-3.77,8.29-8.77,8.88l-1.55.19c-21.91,2.34-31.68,14.94-34.76,28.8h.54c5.44-5.76,12.86-9.18,22.81-9.18,18.65,0,33.49,13.86,33.49,37.62,0,22.32-15.56,41.94-40.36,41.94-28.61,0-43.45-22-43.45-50.22,0-23,8.15-41.22,20.45-52.92,10.5-9.9,24.62-15.48,40.37-16.74h.16c5.91-.6,11.07,3.57,11.07,8.89ZM318.07,78.91c-.18-10.62-5.07-19.8-15.56-19.8a15.58,15.58,0,0,0-14.31,9.54c-.72,1.44-1.26,4-1.26,7.92.36,13.32,6,24.12,16.83,24.12C313,100.69,318.07,91.51,318.07,78.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.17,109.2v-19H362.64c-5.52,0-10-4-10-8.94V75.2A8.13,8.13,0,0,1,353.82,71l38.56-65.1a10.19,10.19,0,0,1,8.82-4.76h14.41c5.52,0,10,4,10,9V70.27H429c5.52,0,10,4,10,9v2.09c0,4.94-4.47,8.94-10,8.94H425.6v19c0,4.94-4.47,9-10,9h-4.45C405.64,118.15,401.17,114.14,401.17,109.2Zm0-38.93V44.89c0-6.84.54-13.86.9-21.06h-.54c-3.44,7.38-6.52,13.68-10.14,20.7L376.55,69.91v.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e8807cecdf0a4151609f0194ad581881.svg";
export { ForwardRef as ReactComponent };